// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7b8f1993","239":"2a013d16","453":"e09ea48f","455":"bc968842","621":"1f76b056","977":"09f1c87a"}[chunkId] + ".chunk.js";
};